import { Registration } from '@/services/types/accredit'
import { makeAutoObservable } from 'mobx'

type ApplicantResult = Partial<Registration> & { birthdayDate?: Date | null }
export class Accredit {
  private _applicant_id: string = '' // 申请人
  private _applicant_result: ApplicantResult = {}
  private _applicant_fee: number = 0 // 费用
  private _applicant_grade: number = 16 // 等级
  private _applicant_code: string = '' // 商品编码

  constructor() {
    makeAutoObservable(this)
  }

  set applicant_id(value: string) {
    this._applicant_id = value
  }
  get applicant_id() {
    return this._applicant_id
  }
  set applicant_grade(value: number) {
    this._applicant_grade = value
  }
  get applicant_grade() {
    return this._applicant_grade
  }
  set applicant_fee(value: number) {
    this._applicant_fee = value
  }
  get applicant_fee() {
    return this._applicant_fee
  }
  set applicant_code(value: string) {
    this._applicant_code = value
  }
  get applicant_code() {
    return this._applicant_code
  }
  set applicant_result(value: ApplicantResult) {
    this._applicant_result = value
  }
  get applicant_result() {
    return this._applicant_result
  }
}

export default new Accredit()
